import { useContext } from 'react';
import UserContext from 'modules/common/context/UserContext';
import { SCORER_USER_GROUP } from 'modules/common/constants';

export function useIsScorerRole() {
  const { userGroups } = useContext(UserContext);

  return userGroups?.includes(SCORER_USER_GROUP);
} 